import { SERVICES } from '../../../data/services';

export default function Services() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-28 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="max-w-[640px] mb-16">
          <p className="text-[13px] font-bold tracking-[0.09em] uppercase text-[#0b5b96] mb-[14px]">Our Services</p>
          <h2 className="font-extrabold text-[#161a20] leading-[1.15] tracking-tight" style={{ fontSize: 'clamp(2.25rem,4vw,3rem)' }}>
            Everything Your Office Deserves
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid gap-7" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))' }}>
          {SERVICES.map((service, index) => (
            <div
              key={index}
              className="group bg-[#f7f8fa] rounded-[20px] overflow-hidden transition-all duration-300 hover:bg-white hover:shadow-[0_24px_48px_-20px_rgba(16,24,40,0.2)] hover:-translate-y-1"
            >
              {/* Service Image */}
              <div className="relative h-[190px] w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.alt}
                  width={600}
                  height={400}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="w-12 h-12 rounded-[14px] bg-[#5FA42B]/[.18] flex items-center justify-center mb-[18px]">
                  <i className={`${service.icon} text-[22px] text-[#0b5b96]`}></i>
                </div>
                <h3 className="text-[21px] font-bold text-[#161a20] mb-3">{service.title}</h3>
                <p className="text-[15.5px] leading-relaxed text-[#5b6472] mb-[18px]">{service.description}</p>
                <button
                  onClick={scrollToContact}
                  className="flex items-center gap-2 bg-none border-none font-bold text-[15px] text-[#0b5b96] hover:text-[#084876] p-0 cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
